import { FormNotifications, CurrentUser, StepperStep, CheckboxSetItem, ActivityStepData } from 'types';

export const getActivitiesStep = (
  user: CurrentUser,
  notifications: Record<string, FormNotifications>,
  activities: Array<Record<string, string> | CheckboxSetItem> | any,
  onPass: (data: ActivityStepData, id: string) => void,
): StepperStep => ({
  stepName: 'Activities',
  onPass: async (data: ActivityStepData) => {
    onPass(data, 'signUpStep4');
  },
  formProps: {
    buttonCaption: 'Finish',
    buttonId: 'registration-complete',
    notifications: notifications,
    marginMode: 'middle',
    fields: [
      {
        type: 'notification',
        fieldName: 'signUpStep4',
      },
      {
        type: 'title',
        fieldName: 'title',
        value: 'Choose some activities to follow',
      },
      {
        type: 'description',
        fieldName: 'value',
        value: 'Select activities you would like to see in your Sendy recommendation feed',
      },
      {
        type: 'iconCheckBlock',
        fieldName: 'activities',
        user: user,
        items: activities,
      },
    ],
  },
});
